
const findCategoryInTree = (categoryID, categories) => {
    // console.log("looking in tree", categories, "for", categoryID);
    if(!categories) {
        return null;
    } else {
        for(const category of categories) {
            if(categoryID === category.id) {
                return category;
            } else {
                const childMatch = findCategoryInTree(categoryID, category.children);
                if(childMatch) return childMatch;
            }
        }
        return null;
    }
}

const findCategory = (categoryMap, categoryID) => {
    if(!categoryMap) {
        return null;
    } else if(categoryID in categoryMap) {
        return categoryMap[categoryID];
    } else {
        return findCategoryInTree(categoryID, Object.values(categoryMap));
    }
}

const getCrumb = (category, selectedID) => {
    return {
        name: category.name,
        nav: "/category/" + category.id,
        selected: category.id === selectedID
    }
}

const getBreadcrumbTrail = (categoryMap, categoryID, selectedID, crumbs = []) => {
    const category = findCategory(categoryMap, categoryID);
    if(category != null) {
        const parentId = category.parentID;
        const crumb = getCrumb(category, selectedID);
        const childCrumbs = getBreadcrumbTrail(categoryMap, parentId, selectedID, crumbs);
        childCrumbs.push(crumb);
        return childCrumbs;
    } else {
        return crumbs;
    }
}

const getTertiaryInTree = (categoryID, categories) => {
    if(!categories) {
        return null;
    } else {
        for(const category of categories) {
            if(categoryID === category.id) {
                if(category.children && category.children.length > 0) {
                    return category.children;
                } else {
                    return categories;
                }
            } else {
                const childMatch = getTertiaryInTree(categoryID, category.children);
                if(childMatch) return childMatch;
            }
        }
        return null;
    }
}

const getTertiaryNav = (categoryMap, categoryID) => {
    if(!categoryMap) {
        return null;
    } else if(categoryID in categoryMap) {
        const item = categoryMap[categoryID];
        if(item.children) {
            return item.children;
        } else {
            return Object.values(categoryMap)
        }
    } else {
        return getTertiaryInTree(categoryID, Object.values(categoryMap));
    }
}

const breadcrumb = {
    getBreadcrumbTrail,
    findCategory,
    getTertiaryNav,
}

export default breadcrumb;
